// extracted by mini-css-extract-plugin
export var icon = "_sd-0";